import { render, staticRenderFns } from "./info_works.vue?vue&type=template&id=08af2053&scoped=true"
import script from "./info_works.vue?vue&type=script&lang=js"
export * from "./info_works.vue?vue&type=script&lang=js"
import style0 from "./info_works.vue?vue&type=style&index=0&id=08af2053&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08af2053",
  null
  
)

export default component.exports